import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';

export default [
  <Route key="/business/showcase/shadefinder/home" element={<ShowocaseLayout />}>
    <Route path="business/showcase/shadefinder/home" element={<AsyncPage />} />
  </Route>,
];
